<template>
  <div
    ref="item"
    class="nt-template__item"
    :class="[topMargin, bottomMargin]"
  >
    <slot />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'nt-template-item',
  props: {
    top: {
      type: String
    },
    bottom: {
      type: String
    },
    fontResize: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const topMargin = ref(null)
    const bottomMargin = ref(null)
    const baseFontSize = 16

    const onResize = () => {
      const windowWidth = window.innerWidth
      const componentWidth = itemRef.value.offsetWidth
      const sm = 768
      const ratio = (baseFontSize * (componentWidth / windowWidth)) * 10
      if (windowWidth > sm) {
        if (ratio > 100) {
          itemRef.value.style.fontSize = '100%'
        } else {
          itemRef.value.style.fontSize = `${ratio < 70 ? '70' : ratio}%`
        }
      } else {
        itemRef.value.style.fontSize = '100%'
      }
    }

    const itemRef = ref(null)

    onMounted(() => {
      if (props.fontResize) {
        window.addEventListener('resize', onResize)
        onResize()
      }
    })

    onUnmounted(() => {
      window.removeEventListener('resize', onResize)
    })

    return { topMargin, bottomMargin, itemRef }
  }
}
</script>
